import React from 'react';
import styled from '@2pulse/responsive';
import { PriceInput } from '@app/components';
import { normalize } from '@app/helpers';

interface CatalogShopPriceInputProps {
  name: string;
  label: string;
  catalogValue: number | null | undefined;
}

export const CatalogShopPriceInput = ({ name, label }: CatalogShopPriceInputProps) => {
  return (
    <Container>
      <PriceInput name={name} label={label} size="small" />
    </Container>
  );
};

const Container = styled.View({
  width: normalize(150),
});
